
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"40","height":"40","viewBox":"0 0 40 40"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"vuesax/twotone/notification-bing"}},[_c('path',{attrs:{"d":"M20 17.533a1.25 1.25 0 01-1.25-1.25v-5.55A1.25 1.25 0 0120 9.483a1.25 1.25 0 011.25 1.25v5.55a1.25 1.25 0 01-1.25 1.25z","fill":"#f29030"}}),_c('path',{attrs:{"data-name":"Vector","d":"M20 39.167a6.842 6.842 0 01-4.8-2 6.842 6.842 0 01-2-4.8h2.5a4.325 4.325 0 001.267 3.033A4.325 4.325 0 0020 36.667a4.3 4.3 0 004.3-4.3h2.5a6.808 6.808 0 01-6.8 6.8z","fill":"#f29030"}}),_c('path',{attrs:{"data-name":"Vector","d":"M20.033 2.083A12.414 12.414 0 0132.4 14.433v3.5a7.577 7.577 0 00.87 3.154l2.119 3.537a4.949 4.949 0 01-2.677 7.245 40.069 40.069 0 01-12.67 2.052 40.068 40.068 0 01-12.671-2.052 4.913 4.913 0 01-3.161-2.936 5.005 5.005 0 01.483-4.309l2.118-3.533a7.448 7.448 0 00.872-3.158v-3.5a12.346 12.346 0 0112.35-12.35zm.008 29.337a37.573 37.573 0 0011.88-1.924 2.45 2.45 0 001.322-3.589l-2.116-3.533a9.984 9.984 0 01-1.227-4.441v-3.5a9.859 9.859 0 00-19.717 0v3.5a9.827 9.827 0 01-1.23 4.446l-2.115 3.53a2.49 2.49 0 00-.286 2.156 2.465 2.465 0 001.609 1.433 37.572 37.572 0 0011.881 1.922z","fill":"#245389"}})])])
          )
        }
      }
    